export default __webpack_public_path__ + "static/char-59-anr-bf723734b018681edf51279b7200cb4b.webp";